class TokenService {
    getLocalRefreshToken() {
      const refreshToken = localStorage.getItem("refresh");
      return refreshToken;
    }
  
    getLocalAccessToken() {
      const accessToken = localStorage.getItem("token");
      return accessToken;
    }
  
    updateLocalAccessToken(accessToken, refreshToken, rememberMe) {
      localStorage.setItem("token", accessToken);
      localStorage.setItem("refresh", refreshToken);
      localStorage.setItem("remember", rememberMe);
    }

    getRememberStatus() {
        const rememberStatus = localStorage.getItem('remember')
        return rememberStatus
    }
  
    removeToken() {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh");
      localStorage.removeItem("remember");
    }
  }
  
  export default new TokenService();